import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';
import { filterToValidAttributes } from '@zocdoc/dom-property';

import { Icon } from './_base';

const CameraSVG = styled(Icon).attrs({ viewBox: '0 0 129.5996 112.7998' })`
    width: 1.1489346612em;
`;

const Camera = ({ color = navy, ...props }) => (
    <CameraSVG
        data-test="icon-camera"
        {...filterToValidAttributes(props)}
    >
        <path
            d="M64.9 90.4a24 24 0 1 1 24-24 24.027 24.027 0 0 1-24 24zm0-36a12 12 0 1 0 12 12 12.014 12.014 0 0 0-12-12z"
            fill={color}
        />
        <path
            d="M129.6 112.8H0V21.6h63.6v12H12v67.2h105.6V12h-16v15.6h-12V0h40v112.8z"
            fill={color}
        />
    </CameraSVG>
);

export {
    Camera as default,
    Camera,
};
